import React from "react";

export interface ResultsTableProps {
  rows: any[];
}

export default function ResultsTable({ rows }: ResultsTableProps) {
  if (rows.length === 0) return null;
  const keys = Object.keys(rows[0]);
  return (
    <table border={1}>
      <thead>
        <tr>
          {keys.map((k) => (
            <th key={k}>{k}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={idx}>
            {keys.map((k) => (
              <td key={k}>{row[k] === undefined ? "" : String(row[k])}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
